import duty from './duty'
import goodscc from './goodscc'
import waybill from './waybill'
import synchro from './synchro'
import labelcc from './labelcc'

const state = {
  info: {},
}

const getters = {
}

const mutations = {
}

const actions = {
  userProfile ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/cc/user-profile', {params})
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    duty,
    goodscc,
    waybill,
    synchro,
    labelcc,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cc/index.js